import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponseWithQData } from "../../../types/common";
import { ITransactionPopulated } from "@src/types/api/transaction";

export async function transactionList(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<ITransactionPopulated[]>>> {
  return axios.get(API_ENDPOINTS.TRANSACTION_LIST, {
    params: qData,
  });
}

